/**
 * Zone flags — must be imported before zone.js in polyfills.ts.
 *
 * These flags prevent Zone from patching certain browser APIs that are heavily
 * used by third-party scripts (reCAPTCHA, Intercom, Segment, ProfitWell, etc.).
 * Without these flags, every timer or event callback from those scripts triggers
 * NgZone.onMicrotaskEmpty, which the ngUpgrade bridge converts into an AngularJS
 * $digest, causing hundreds of unnecessary digests per second while the app idles.
 *
 * Do NOT add event names to __zone_symbol__UNPATCHED_EVENTS without verifying
 * that no Angular component uses that event for change detection. Angular's
 * renderer uses standard addEventListener which relies on Zone patching —
 * unpatching an event breaks any (eventName) template binding or @HostListener
 * that uses it. For example, mouseenter/mouseleave are used in
 * DowngradePlanContentComponent and LeadSearchComponent.
 *
 * Do NOT disable setTimeout/setInterval — Angular's own scheduler,
 * AngularJS $timeout/$interval, and the ngUpgrade bridge all depend on those
 * being Zone-patched to trigger change detection at the right times.
 */

// reCAPTCHA uses requestAnimationFrame heavily for its internal polling loops.
// Angular's rendering scheduler does not depend on Zone-patched RAF — it uses
// its own scheduler internally. Disabling this prevents reCAPTCHA's RAF
// callbacks from triggering NgZone.onMicrotaskEmpty → AngularJS $digest on
// every animation frame.
(window as any).__Zone_disable_requestAnimationFrame = true;
